import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import {postFutureType } from '../../api/featurecatalog';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { InputLabel, Input, FormHelperText } from '@material-ui/core';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import MUIDataTable from "mui-datatables";
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { connect } from 'react-redux';
import _ from 'lodash';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Alert, AlertTitle } from '@material-ui/lab';
import { pushProperty } from '../../actions/general';
import { generateRDFAll, generateRDFCatalogOnly, generateRDFloop, generateRDFloopx } from '../../api/featurecatalog';

import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";

const override = css`
position: absolute;
  top: 50%;
  left: 40%;
  margin: 0 auto;
`;

class AddFeatureType extends Component{

  constructor(props) {
    super(props);
    this.state = {
      actionPT: "add",
      mode:"property",

      aliases : "",
      attributVersionNumber: "",
      attributeIsAbstract: "",
      bfAtribute: "",
      code: "",
      open: false,
      date: "",
      definition: "",
      faCode: "",
      faValueMeasurementUnit: "",
      faValueType: "",
      fcAssociationRole: "",
      fcConstraint: "",
      fcDefinitionReference: "",
      fcDefinitionReference1: "",
      fcDefinitionSource: "",
      fcFeatureAssociation: "",
      fcFeatureOperation: "",
      fcName: "",
      fcProducer: "",
      fcProducer1: "",
      featureCatalogue: "",
      featureCatalogueId: this.props.featureCatalogueId,
      featureTypeID: "",
      inheritanceDescription: "",
      inheritanceName: "",
      inheritanceSubtype: "",
      inheritanceSupertype: "",
      kode: "",
      role: "",
      typeName: "",
      loading: false,
      lvCode: "",
      lvCodeDetail: "",
      lvLabel: "",
      ptCardinality: "",
      ptDefinition: "",
      ptMemberName: "",

      dataPT: [],
      dataLV: [],
      ptMemberNameLast: ""
    }
  }

  componentWillMount(){
    console.log(this.props.featureCatalogueId);
  }

  handleChangeText = (keys,e) => {
      this.setState({ [keys]: e.target.value });
  };

  handleClose = ()=>{
    this.setState({open:!this.state.open});
  }

  submitFormLV = ()=>{
    let dataPush = {
      ptCardinality: this.state.ptCardinality,
      ptMemberName:this.state.ptMemberName,
      ptDefinition: this.state.ptDefinition,
      lvCode: this.state.lvCode,
      lvCodeDetail: this.state.lvCodeDetail,
      lvLabel: this.state.lvLabel,
      faValueMeasurementUnit:this.state.faValueMeasurementUnit,
      faValueType:this.state.faValueType,
      fcDefinitionReference1:this.state.fcDefinitionReference1,
      fcProducer1:this.state.fcProducer1,
      bfAtribute:this.state.bfAtribute,
      faCode:this.state.faCode,
      fcConstraint:this.state.fcConstraint

    }
    this.setState({dataLV: [dataPush, ...this.state.dataLV]})
    this.setState({open:!this.state.open});
  }

  submitFormPT = ()=>{

    let dataPT = this.state.dataPT;
    let dataLV = this.state.dataLV;
    let dataLVTemp = [];
    let ptMemberNameLast = this.state.ptMemberNameLast;
    this.setState({open:!this.state.open});
    // console.log(this.state.ptCardinality, this.state.ptMemberName, this.state.ptDefinition);

    if(this.state.actionPT == "edit"){
      //delete property lama
      let b = _.remove(dataPT, function(currentObject) {
          return currentObject.ptMemberName !== ptMemberNameLast;
      });
      dataPT = b;

      //tampung lv lama
      dataLV.map((e)=>{
        if(e.ptMemberName == this.state.ptMemberNameLast){
          dataLVTemp.push({
            ptCardinality: this.state.ptCardinality,
            ptMemberName:this.state.ptMemberName,
            ptDefinition: this.state.ptDefinition,
            faValueMeasurementUnit:this.state.faValueMeasurementUnit,
            faValueType:this.state.faValueType,
            fcDefinitionReference1:this.state.fcDefinitionReference1,
            fcProducer1:this.state.fcProducer1,
            bfAtribute:this.state.bfAtribute,
            faCode:this.state.faCode,
            fcConstraint:this.state.fcConstraint,
            lvCode: e.lvCode,
            lvCodeDetail: e.lvCodeDetail,
            lvLabel: e.lvLabel
          });
        }


      })

      //delete lv lama
      console.log(dataLV);
      console.log(ptMemberNameLast);

      let bb = _.remove(dataLV, function(currentObject) {
          return currentObject.ptMemberName !== ptMemberNameLast;
      });
      dataLV = bb;

      console.log(dataLVTemp);

      //add lv baru

      let lvfinal = dataLVTemp.concat(dataLV);

      this.setState({dataLV: lvfinal});

    } else

    if(this.state.actionPT == "add"){
      //add lv default
      let dataPush2 = {
        ptCardinality: this.state.ptCardinality,
        ptMemberName:this.state.ptMemberName,
        ptDefinition: this.state.ptDefinition,
        faValueMeasurementUnit:this.state.faValueMeasurementUnit,
        faValueType:this.state.faValueType,
        fcDefinitionReference1:this.state.fcDefinitionReference1,
        fcProducer1:this.state.fcProducer1,
        bfAtribute:this.state.bfAtribute,
        faCode:this.state.faCode,
        fcConstraint:this.state.fcConstraint,
        lvCode: "-",
        lvCodeDetail: "-",
        lvLabel: "-"
      }
      this.setState({dataLV: [dataPush2, ...dataLV]})

    }


    //add property type
    let dataPush = {
      ptCardinality: this.state.ptCardinality,
      ptMemberName:this.state.ptMemberName,
      ptDefinition: this.state.ptDefinition,
      faValueMeasurementUnit:this.state.faValueMeasurementUnit,
      faValueType:this.state.faValueType,
      fcDefinitionReference1:this.state.fcDefinitionReference1,
      fcProducer1:this.state.fcProducer1,
      bfAtribute:this.state.bfAtribute,
      faCode:this.state.faCode,
      fcConstraint:this.state.fcConstraint
    }
    this.setState({dataPT: [dataPush, ...dataPT]})


  }

  submitForm = () => {

    // generateRDFAll()
    //   .then(response => {
    //     console.log(response);
    // }).catch(error => {
    //   console.log(error);
    // });
    // generateRDFCatalogOnly()
    //   .then(response => {
    //     console.log(response);
    // }).catch(error => {
    //   console.log(error);
    // });
    //
    // generateRDFloop()
    //   .then(response => {
    //     console.log(response);
    // }).catch(error => {
    //   console.log(error);
    // });
    // generateRDFloopx()
    //   .then(response => {
    //     console.log(response);
    // }).catch(error => {
    //   console.log(error);
    // });
    //postFutureType
    let dataSubmit = this.state;

    delete dataSubmit.lvCode;
    delete dataSubmit.lvCodeDetail;
    delete dataSubmit.lvLabel;
    delete dataSubmit.ptCardinality;
    delete dataSubmit.ptDefinition;
    delete dataSubmit.ptMemberName;
    delete dataSubmit.faValueMeasurementUnit;
    delete dataSubmit.faValueType;
    delete dataSubmit.fcDefinitionReference1;
    delete dataSubmit.fcProducer1;
    delete dataSubmit.bfAtribute;
    delete dataSubmit.faCode;
    delete dataSubmit.fcConstraint;


    this.setState({loading:true});

    dataSubmit.dataLV.map((e)=>{

      let datafinal = _.merge({}, dataSubmit, e);

      postFutureType(datafinal)
        .then(response => {
          //this.props.pushCategory(response.data);
          this.setState({loading:false});
          this.props.handleOpen(false);
          this.props.handleReload(true);
        })
        .catch(error => {
          console.log(error);
        });

    })



  }

  renderListValue = (e)=>{

    return (
      <div style = {{padding:10}}>

        <Table  aria-label="simple table">
          <TableHead>
            <TableRow style={{height: 1}}>
              <TableCell style = {{borderBottom: "none", width:"30%", bgColor:"#969199", padding: 0}}>List Value Code</TableCell>
              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>List Value Code Detail</TableCell>
              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>List Value Label</TableCell>
              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow style={{height: 1}}>
              <TableCell style = {{borderBottom: "none", padding: 0}}>{e.lvCode}</TableCell>
              <TableCell style = {{borderBottom: "none", padding: 0}}>{e.lvCodeDetail}</TableCell>
              <TableCell style = {{borderBottom: "none", padding: 0}}>{e.lvLabel}</TableCell>
              <TableCell style = {{borderBottom: "none", padding: 0}}>
                <IconButton onClick={()=>{
                  let a = this.state.dataLV;
                  console.log(this.state.dataLV);
                  let b = _.remove(a, function(currentObject) {
                      return currentObject.lvCode !== e.lvCode;
                  });
                  this.setState({dataLV: b});
                }}>
                  <DeleteIcon color="primary" style = {{cursor:"pointer"}} />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    )
  }

  handlePTDel = (e)=>{
    console.log(e);
  }

  renderProperty = (e)=>{

    let aa = _.filter(this.state.dataLV, { 'ptMemberName': e.ptMemberName});

    console.log(this.state.dataLV);
    console.log(aa);


    return(
      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Table  aria-label="simple table">
          <TableHead>
            <TableRow style={{height: 1}}>
              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>Member Name</TableCell>
              <TableCell style = {{borderBottom: "none", width:"30%", bgColor:"#969199", padding: 0}}>Definition</TableCell>

              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>Cardinality</TableCell>
              <TableCell style = {{borderBottom: "none", width:"30%", padding: 0}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow style={{height: 1}}>
            <TableCell style = {{borderBottom: "none", padding: 0}}>{e.ptMemberName}</TableCell>
              <TableCell style = {{borderBottom: "none", padding: 0}}>{e.ptDefinition}</TableCell>

              <TableCell style = {{borderBottom: "none", padding: 0}}>{e.ptCardinality}</TableCell>
              <TableCell style = {{borderBottom: "none", padding: 0}}>
                <IconButton onClick={()=>{
                  this.setState({open:true,mode:"property", ptDefinition: e.ptDefinition, ptMemberName: e.ptMemberName, ptCardinality:e.ptCardinality, actionPT: "edit", ptMemberNameLast: e.ptMemberName});
                }}>
                  <BorderColorTwoToneIcon color="primary" style = {{cursor:"pointer"}} />
                </IconButton>
                <IconButton onClick={()=>{
                  let a = this.state.dataPT;
                  let aa = this.state.dataLV;

                  let b = _.remove(a, function(currentObject) {
                      return currentObject.ptMemberName !== e.ptMemberName;
                  });

                  let bb = _.remove(aa, function(currentObject) {
                      return currentObject.ptMemberName !== e.ptMemberName;
                  });

                  this.setState({dataPT: b, dataLV:bb});
                }}>
                  <DeleteIcon color="primary" style = {{cursor:"pointer"}} />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails>
          <Paper style={{width:"100%"}}>

          <Grid item xs={12}>
          <Table  aria-label="simple table">
            <TableBody>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Kode Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faCode}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Satuan Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faValueMeasurementUnit}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Jenis Satuan Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faValueType}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Referensi Definisi Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcDefinitionReference1}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Produsen</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcProducer1}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Pembatasan</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcConstraint}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Bound Feature Atribute</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.bfAtribute}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
            </TableBody>

          </Table>
          </Grid>
            <div style = {{padding:5}}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                color="secondary"
                onClick = {()=>{
                  this.setState({open: !this.state.open, mode: "list", ptMemberName: e.ptMemberName, ptDefinition:e.ptDefinition, ptCardinality:e.ptCardinality});

                }} >
                  List Value
              </Button>
            </div>
            <div>
              {aa.map(this.renderListValue)}
            </div>
          </Paper>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }

  renderAddType = () => {


    if(this.state.mode == "property"){

      return (
        <div>
        <Alert severity="info">Tambah Property Unsur</Alert>
          <DialogContent>
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="ptCardinality">Property Type Cardinality</InputLabel>
            <Input id="ptCardinality" aria-describedby="Property Type Cardinality"
              value = {this.state.ptCardinality}
              onChange = {(e) => this.handleChangeText("ptCardinality",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="ptMemberName">Member Name</InputLabel>
            <Input id="ptMemberName" aria-describedby="Member Name"
              value = {this.state.ptMemberName}
              onChange = {(e) => this.handleChangeText("ptMemberName",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="ptDefinition">Property Type Definition</InputLabel>
            <Input id="ptDefinition" aria-describedby="Property Type Definition"
              value = {this.state.ptDefinition}
              onChange = {(e) => this.handleChangeText("ptDefinition",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="faCode">Kode Atribut</InputLabel>
            <Input id="faCode" aria-describedby="Kode Atribut"
              value = {this.state.faCode}
              onChange = {(e) => this.handleChangeText("faCode",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="faValueMeasurementUnit">Satuan Atribut</InputLabel>
            <Input id="faValueMeasurementUnit" aria-describedby="Satuan Atribut"
              value = {this.state.faValueMeasurementUnit}
              onChange = {(e) => this.handleChangeText("faValueMeasurementUnit",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="faValueType">Jenis Satuan Atribut</InputLabel>
            <Input id="faValueType" aria-describedby="Jenis Satuan Atribut"
              value = {this.state.faValueType}
              onChange = {(e) => this.handleChangeText("faValueType",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="fcDefinitionReference1">Referensi Definisi Atribut	</InputLabel>
            <Input id="fcDefinitionReference1" aria-describedby="Referensi Definisi Atribut"
              value = {this.state.fcDefinitionReference1}
              onChange = {(e) => this.handleChangeText("fcDefinitionReference1",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="fcProducer1">Produsen</InputLabel>
            <Input id="fcProducer1" aria-describedby="Produsen"
              value = {this.state.fcProducer1}
              onChange = {(e) => this.handleChangeText("fcProducer1",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="fcConstraint">Pembatasan</InputLabel>
            <Input id="fcConstraint" aria-describedby="Pembatasan"
              value = {this.state.fcConstraint}
              onChange = {(e) => this.handleChangeText("fcConstraint",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="bfAtribute">Bound Feature Atribute</InputLabel>
            <Input id="bfAtribute" aria-describedby="Bound Feature Atribute"
              value = {this.state.bfAtribute}
              onChange = {(e) => this.handleChangeText("bfAtribute",e)}
            />
          </FormControl>{' '}
          <div style = {{padding:2}}>
            <Button variant="contained" startIcon={<AddIcon />} color="primary" onClick = {this.submitFormPT} > Save </Button>
          </div>
          </DialogContent>
        </div>
      )
    }else{
      return (
        <div>
        <Alert severity="info">Tambah List Value</Alert>
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="lvCode">List Value Code</InputLabel>
            <Input id="lvCode" aria-describedby="List Value Code"
              //value = {this.state.lvCode}
              onChange = {(e) => this.handleChangeText("lvCode",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="lvCodeDetail">List Value Code Detail</InputLabel>
            <Input id="lvCodeDetail" aria-describedby="List Value Code Detail"
              //value = {this.state.lvCodeDetail}
              onChange = {(e) => this.handleChangeText("lvCodeDetail",e)}
            />
          </FormControl>{' '}
          <FormControl style={{ margin: 10 }}>
            <InputLabel htmlFor="lvLabel">List Value Label</InputLabel>
            <Input id="lvLabel" aria-describedby="List Value Label"
              //value = {this.state.lvLabel}
              onChange = {(e) => this.handleChangeText("lvLabel",e)}
            />
          </FormControl>{' '}
          <div style = {{padding:2}}>
            <Button variant="contained" startIcon={<AddIcon />} color="primary" onClick = {this.submitFormLV} > Save </Button>
          </div>
        </div>
      )

    }

  }

  render(){

    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={false}
          maxWidth= {'md'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle disableTypography style = {{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          >

              <IconButton onClick={this.handleClose}>
                  <CloseIcon />
              </IconButton>
          </DialogTitle>

          <DialogContent>
            {this.renderAddType()}
          </DialogContent>
        </Dialog>
        <Card style = {{padding:10}}>
        <Alert severity="info">Add Unsur</Alert>
        <div style = {{padding:10}}>

        <div className="sweet-loading">
          <BarLoader
            css={override}
            height={4}
            width={300}
            color={"#C51162"}
            loading={this.state.loading}
          />
        </div>

        <FormControl style={{ margin: 10 }} >
          <InputLabel htmlFor="aliases">aliases</InputLabel>
          <Input id="aliases" aria-describedby="aliases"
            value = {this.state.aliases}
            fullWidth = {true}
            onChange = {(e) => this.handleChangeText("aliases",e)}
          />
        </FormControl>
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="attributVersionNumber">attributVersionNumber</InputLabel>
          <Input id="attributVersionNumber" aria-describedby="attributVersionNumber"
            value = {this.state.attributVersionNumber}
            onChange = {(e) => this.handleChangeText("attributVersionNumber",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="attributeIsAbstract">attributeIsAbstract</InputLabel>
          <Input id="attributeIsAbstract" aria-describedby="attributeIsAbstract"
            value = {this.state.attributeIsAbstract}
            onChange = {(e) => this.handleChangeText("attributeIsAbstract",e)}
          />
        </FormControl>{' '}

        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="code">code</InputLabel>
          <Input id="code" aria-describedby="code"
            value = {this.state.code}
            onChange = {(e) => this.handleChangeText("code",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="date">date</InputLabel>
          <Input id="date" aria-describedby="date"
            value = {this.state.date}
            onChange = {(e) => this.handleChangeText("date",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="definition">definition</InputLabel>
          <Input id="definition" aria-describedby="definition"
            value = {this.state.definition}
            onChange = {(e) => this.handleChangeText("definition",e)}
          />
        </FormControl>{' '}



        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcAssociationRole">fcAssociationRole</InputLabel>
          <Input id="fcAssociationRole" aria-describedby="fcAssociationRole"
            value = {this.state.fcAssociationRole}
            onChange = {(e) => this.handleChangeText("fcAssociationRole",e)}
          />
        </FormControl>{' '}

        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcDefinitionReference">fcDefinitionReference</InputLabel>
          <Input id="fcDefinitionReference" aria-describedby="fcDefinitionReference"
            value = {this.state.fcDefinitionReference}
            onChange = {(e) => this.handleChangeText("fcDefinitionReference",e)}
          />
        </FormControl>{' '}

        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcDefinitionSource">fcDefinitionSource</InputLabel>
          <Input id="fcDefinitionSource" aria-describedby="fcDefinitionSource"
            value = {this.state.fcDefinitionSource}
            onChange = {(e) => this.handleChangeText("fcDefinitionSource",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcFeatureAssociation">fcFeatureAssociation</InputLabel>
          <Input id="fcFeatureAssociation" aria-describedby="fcFeatureAssociation"
            value = {this.state.fcFeatureAssociation}
            onChange = {(e) => this.handleChangeText("fcFeatureAssociation",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcFeatureOperation">fcFeatureOperation</InputLabel>
          <Input id="fcFeatureOperation" aria-describedby="fcFeatureOperation"
            value = {this.state.fcFeatureOperation}
            onChange = {(e) => this.handleChangeText("fcFeatureOperation",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcName">fcName</InputLabel>
          <Input id="fcName" aria-describedby="fcName"
            value = {this.state.fcName}
            onChange = {(e) => this.handleChangeText("fcName",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="fcProducer">fcProducer</InputLabel>
          <Input id="fcProducer" aria-describedby="fcProducer"
            value = {this.state.fcProducer}
            onChange = {(e) => this.handleChangeText("fcProducer",e)}
          />
        </FormControl>{' '}

        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="featureCatalogue">featureCatalogue</InputLabel>
          <Input id="featureCatalogue" aria-describedby="featureCatalogue"
            value = {this.state.featureCatalogue}
            onChange = {(e) => this.handleChangeText("featureCatalogue",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="inheritanceDescription">inheritanceDescription</InputLabel>
          <Input id="inheritanceDescription" aria-describedby="inheritanceDescription"
            value = {this.state.inheritanceDescription}
            onChange = {(e) => this.handleChangeText("inheritanceDescription",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="inheritanceName">inheritanceName</InputLabel>
          <Input id="inheritanceName" aria-describedby="inheritanceName"
            value = {this.state.inheritanceName}
            onChange = {(e) => this.handleChangeText("inheritanceName",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="inheritanceSubtype">inheritanceSubtype</InputLabel>
          <Input id="inheritanceSubtype" aria-describedby="inheritanceSubtype"
            value = {this.state.inheritanceSubtype}
            onChange = {(e) => this.handleChangeText("inheritanceSubtype",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="inheritanceSupertype">inheritanceSupertype</InputLabel>
          <Input id="inheritanceSupertype" aria-describedby="inheritanceSupertype"
            value = {this.state.inheritanceSupertype}
            onChange = {(e) => this.handleChangeText("inheritanceSupertype",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="kode">kode</InputLabel>
          <Input id="kode" aria-describedby="kode"
            value = {this.state.kode}
            onChange = {(e) => this.handleChangeText("kode",e)}
          />
        </FormControl>{' '}

        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="role">role</InputLabel>
          <Input id="role" aria-describedby="role"
            value = {this.state.role}
            onChange = {(e) => this.handleChangeText("role",e)}
          />
        </FormControl>{' '}
        <FormControl style={{ margin: 10 }}>
          <InputLabel htmlFor="role">typeName</InputLabel>
          <Input id="typeName" aria-describedby="typeName"
            value = {this.state.typeName}
            onChange = {(e) => this.handleChangeText("typeName",e)}
          />
        </FormControl>{' '}
        </div>

        <div style = {{padding:10}}>
          <h5>Property Type</h5>
          <FormControl style={{ margin: 5 }}>
            <Button variant="contained" startIcon={<AddIcon />} color="secondary" onClick = {()=>{this.setState({open: !this.state.open, mode: "property", ptDefinition:"", ptCardinality:"", ptMemberName: "", actionPT:"add"})}} > Property Type</Button>
          </FormControl>{' '}
          <br/>

          {this.state.dataPT.map(this.renderProperty)}
          </div>
          <br/><br/>
          <Button variant="contained" startIcon={<SaveIcon />} color="primary" onClick = {this.submitForm} >Save</Button>

        </Card>
        </div>
    )
  }
}

const mapStatetoProps = state => {

    return {
        propertyType: state.propertyType
    };
}

export default connect(mapStatetoProps, {pushProperty})(AddFeatureType);
